/**
 * 通讯类
 */
import axios from 'axios';
import GlobalInfo from '../GlobalInfo.vue';
import tools from './tools.vue';
import {
	message
} from 'ant-design-vue';
import { handleUnauthorized, isWhiteList } from './auth.js';
axios.defaults.timeout = 10000;
axios.defaults.baseURL = GlobalInfo.HTTPURL;
// 启用 withCredentials 以发送 cookie
axios.defaults.withCredentials = true;

// 添加响应拦截器
axios.interceptors.response.use(
	response => {
		// 如果响应状态码是402，表示未登录
		if (response.data && response.data.code === 402) {
			// 检查当前页面是否在白名单中
			const currentPath = window.location.pathname;
			if (!isWhiteList(currentPath)) {
				// 只有非白名单页面才跳转登录
				handleUnauthorized();
			}
			return Promise.reject(response);
		}
		return response;
	},
	error => {
		// 如果HTTP状态码是402，也表示未登录
		if (error.response && error.response.status === 402) {
			// 检查当前页面是否在白名单中
			const currentPath = window.location.pathname;
			if (!isWhiteList(currentPath)) {
				// 只有非白名单页面才跳转登录
				handleUnauthorized();
			}
		}
		return Promise.reject(error);
	}
);
/**
 * 正常请求
 * @param {*请求类型:post、get、put、del} type 
 * @param {*请求URL地址} url 
 * @param {*数据} data 
 */
export function request(type, url, data = {}) {
	return new Promise((resolve, reject) => {
		axios[type](url, data).then(res => {
			if (res.data.code != 200) {
				message.error(res.data.msg)
			};
			resolve(res.data)
		}, err => {
			resolve(err)
		})
	})
};

/**
 * token请求
 * @param {*请求类型:post、get、put、del} type 
 * @param {*请求URL地址} url 
 * @param {*数据} data 
 */
export function reqToken(type, url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
        // 合并配置，支持超时时间等参数
        const axiosConfig = {
            timeout: config.timeout || 10000, // 默认10秒，可通过config覆盖
            ...config
        };
        
        switch (type) {
            case "post":
                axios[type](url, data, axiosConfig).then(res => {
                    resolve(res.data)
                }, err => {
                    resolve(err)
                })
                break;
            case "get":
                axios.get(url, {
                    params: data,
                    ...axiosConfig
                }).then(res => {
                    resolve(res.data)
                }, err => {
                    resolve(err)
                })
                break;
        }
    })
};